import MostRecentChallengeResponse from './MostRecentChallengeResponse';

export default MostRecentChallengeResponse;
